export default {
  APP: process.env.VUE_APP_TITLE,
  API_URL: process.env.VUE_APP_API_URL,
  baseURL: process.env.VUE_APP_ASSETS_URL,
  // EMP_PHOTO_URL: process.env.VUE_APP_API_URL + 'assets/employee_photo/',
  LIST_MONTHS: [
	  { ID: 1, Name: 'Januari' },
	  { ID: 2, Name: 'Februari' },
	  { ID: 3, Name: 'Maret' },
	  { ID: 4, Name: 'April' },
	  { ID: 5, Name: 'Mei' },
	  { ID: 6, Name: 'Juni' },
	  { ID: 7, Name: 'Juli' },
	  { ID: 8, Name: 'Agustus' },
	  { ID: 9, Name: 'September' },
	  { ID: 10, Name: 'Oktober' },
	  { ID: 11, Name: 'November' },
	  { ID: 12, Name: 'Desember' }
	],
  LIST_YEARS: [
    (new Date()).getFullYear() - 5,
    (new Date()).getFullYear() - 4,
    (new Date()).getFullYear() - 3,
    (new Date()).getFullYear() - 2,
    (new Date()).getFullYear() - 1,
    (new Date()).getFullYear()
  ],
  STYLE_PRINTING: `
    body {
      font-family: Times, "Times New Roman", serif;
    }

    h2 {
      font-size: 1em;
      line-height: 0.5em;
      text-transform: uppercase;
    }

    h4 {
      font-size: 0.8em;
      line-height: 0em;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    td, th {
      font-size: 0.8em;
      padding-left: 3px;
      padding-right: 3px;
    }

    .text-center {
      text-align: center;
    }

    .underlined {
      text-decoration: underline;
    }

    .box {
      width: 300px;
      text-align: center;
    }
  `,
  TEMPLATE_PRINT_HEADER: `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Gaji</title>
      <style>
        h2 {
          font-size: 1em;
          line-height: 0.5em;
        }

        h4 {
          font-size: 0.8em;
          line-height: 0em;
        }

        table {
          border-collapse: collapse;
          width: 100%;
        }

        td, th {
          font-size: 0.8em;
          padding-left: 3px;
          padding-right: 3px;
        }

        .text-center {
          text-align: center;
        }

        .underlined {
          text-decoration: underline;
        }

        .box {
          width: 300px;
          text-align: center;
        }
      </style>
    </head>
    <body>
  `,
  TEMPLATE_PRINT_FOOTER: `
    </body>
    </html>
  `
}
